var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBustGroup = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 119 119",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M35.936 46.582v6.926c0 5.886-4.715 10.671-10.577 10.776",
  stroke: "#A4ABB7",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m33.783 72.45-2.152-2.152v-8.214c2.609-1.965 4.305-5.054 4.305-8.576v-6.926c0-6.307-5.405-11.338-11.84-10.73-5.605.539-9.723 5.558-9.723 11.186v6.47c0 3.51 1.708 6.61 4.306 8.576v8.67L3.902 76.663M83.473 46.582v6.926c0 5.886 4.716 10.671 10.577 10.776",
  stroke: "#A4ABB7",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m85.638 72.45 2.153-2.152v-8.214c-2.61-1.965-4.306-5.054-4.306-8.576v-6.926c0-6.307 5.406-11.338 11.84-10.73 5.605.539 9.723 5.558 9.723 11.186v6.47c0 3.51-1.708 6.61-4.305 8.576v8.67l14.777 5.909",
  stroke: "#A4ABB7",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M69.117 56.938v11.29l21.084 6.447c3.568 1.088 5.733 4.2 6.154 7.921v22.347M23.054 105.223v-22.64c.422-3.709 2.575-6.82 6.155-7.92l21.083-6.447V60.4l.07-3.873-.842-.877a17.584 17.584 0 0 1-4.306-8.729l-.152-.83a17.916 17.916 0 0 1-.28-3.16v-7.335c0-8.237 6.68-14.918 14.917-14.918s14.917 6.669 14.917 14.906v7.511c0 1.065-.093 2.118-.28 3.16l-.153.83a17.78 17.78 0 0 1-4.305 8.728 17.66 17.66 0 0 1-8.003 5.043 6.96 6.96 0 0 1-1.895.293 7.232 7.232 0 0 1-2.118-.293",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M50.304 68.45v7.909h2.936l5.815-4.411h2.165l4.96 4.41h2.937V68.45M59.71 80.523v26.408",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M1 59.5c0-.853.023-1.707.058-2.55C2.392 25.828 28.05 1 59.5 1s57.108 24.816 58.441 55.95c.036.843.059 1.697.059 2.55",
  stroke: "#F15B35",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M115.847 75.272C108.956 99.912 86.34 118 59.5 118S10.032 99.924 3.153 75.271",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgBustGroup;